import { AgGridColumnExt } from "../../../../shared/services/ag-grid/agGridColumnExt";
import ApiService from "../../../../shared/services/apiService";
import { API_ENDPOINT, ENTITY_TYPE } from "../../../../shared/types/enums";

export default class RuleSummaryService {

  static getRuleSummaryAsOBS = (_tenantId, _userId, _modalAgNode) => {

    const targetUrl = `/RuleSummary/FetchRuleSummaryByEntity/${_tenantId}/${ENTITY_TYPE.PROFILE}?id=${_modalAgNode.prid}&pageNumber=1&pageSize=5000`;

    return ApiService.getOBS(
      API_ENDPOINT.CORE,
      targetUrl,
    );
  };

  static setRuleViolations = (_params) => {
    _params.data.ruleviolations = _params.newValue;
    return true;
  }

  /**
   * Refer url for more details: https://www.ag-grid.com/javascript-grid-column-properties/
   * @param _componentThisRef pass {this} keyword from the calling componenet
   */
  static getColumnDefs(_componentThisRef) {
    return [
      AgGridColumnExt.GET(false, "text", "businessRuleSeverity", "Rule Severity").minAndDefaultWidth(144).valueSetter(this.setRuleViolations).SET(),
      AgGridColumnExt.GET(false, "text", "businessRuleMessage", "Rule Message").flexWeight(6).tooltip().valueSetter(this.setRuleViolations).SET(),
      AgGridColumnExt.GET(false, "text", "fieldValue", "Bad Value").flexWeight(6).tooltip().valueSetter(this.setRuleViolations).SET(),
      AgGridColumnExt.GET(false, "text", "businessRuleName", "Rule Name").flexWeight(4).tooltip().valueSetter(this.setRuleViolations).SET(),
    ];
  }
}